import { render, staticRenderFns } from "./V8SkPenggunaan.vue?vue&type=template&id=7f65afc4&"
import script from "./V8SkPenggunaan.vue?vue&type=script&lang=js&"
export * from "./V8SkPenggunaan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports